import React from 'react';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  SingleDropdown,
  useSingleDropdown,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  fetchOptions: (id: string, term: string) => Promise<{ items: Item[] }>;
  onUpdate: (val: FieldObject) => void;
};

const SelectOption = ({ fieldObject, fetchOptions, onUpdate }: Props) => {
  const fieldLabel = fieldObject.fieldLabel();
  const value = fieldObject.selection as Item | null;

  const onSelectionChange = (e: { selectedItem?: Item | null }) => {
    const newValue = e?.selectedItem || null;
    fieldObject.setSelection(newValue);
    onUpdate(fieldObject);
  };

  const dropdownProps = useSingleDropdown({
    fetchItems: (term: string) =>
      fetchOptions(fieldObject.fieldId() as string, term),
    onSelectedItemChange: onSelectionChange,
    selectedItem: value as Item | null,
    preventLoadOnMount: true,
  });

  return (
    <SingleDropdown dropdownProps={dropdownProps}>
      <SingleDropdown.Field
        data-provides="talent-search-single-select-dropdown"
        label={t('search_option', { option: fieldLabel })}
        clearable={false}
      />
      <SingleDropdown.Flyout />
    </SingleDropdown>
  );
};

export default SelectOption;
